
























import {Component, Vue} from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import PaymentForm from "@/components/for-payments-view/PaymentForm.vue";
import PaymentDisabled from "@/components/for-payments-view/PaymentDisabled.vue";
import PaymentDocumentsTable from "@/components/for-payments-view/PaymentDocumentsTable.vue";
import HelpCard from "@/components/for-payments-view/HelpCard.vue";
import {mapGetters, mapState} from "vuex";
import {paymentForm} from "@/assets/scripts/form-fields/main";

const { values } = paymentForm;

@Component({
  components: { Page, PaymentDocumentsTable, PaymentForm, HelpCard, PaymentDisabled },
  computed: {
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({
      // userEmail: "user/email",
      // contractInactive: "contract/inactive",
      contractClosed: "contract/closed",
    }),
  },
})
class Payments extends Vue {
  [x: string]: any;
  values = values;

  docs: any[] = []

  mounted() {
    const {docs} = this;
    const amount = 0;
    this.values = {...this.values, ...{amount, docs}}; // , email: this.userEmail
    this.defaultValues = {...this.values}; // , email: this.userEmail
  }

  get paymentDisabled() {
    return this.contractClosed; // || this.contractInactive
  }
}

export default Payments;
